import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import axiosInstance from '../../../config/api';
import { notification } from 'antd';

export const fetchNearServiceProviders = createAsyncThunk(
    'nearSp/fetchByLatLng',
    async (usersCoordinates, { rejectWithValue }) => {
        if (usersCoordinates) {
            const { latitude, longitude } = usersCoordinates;
            try {
                const resp = await axiosInstance.get(`/service/service-provider?latitude=${latitude}&longitude=${longitude}`);
                if (resp.status === 200) {
                    return resp?.data?.data?.serviceProviders;
                } else {
                    return rejectWithValue('Failed to fetch service providers');
                }
            } catch (error) {
                // return rejectWithValue(error.response?.data?.error?.message || 'An error occurred');
                return rejectWithValue(error.response?.data?.error?.message);
            }
        }
    }
)

const initialState = {
    loading: false,
    serviceProviders: [],
    error: null
}

export const nearSpSlice = createSlice({
    name: "nearSp",
    initialState,
    reducers: {
        nearSpCleaner: (state) => {
            state.serviceProviders = []
        }
    },
    extraReducers: (builder) => {
        builder.addCase(fetchNearServiceProviders.pending, (state) => {
            state.loading = true;
            state.serviceProviders = [];
            state.error = null
        });
        builder.addCase(fetchNearServiceProviders.fulfilled, (state, action) => {
            state.loading = false;
            state.serviceProviders = action.payload
            state.error = null
        });
        builder.addCase(fetchNearServiceProviders.rejected, (state, action) => {
            state.loading = false;
            state.serviceProviders = []
            state.error = action.payload || 'Failed to fetch service providers';
        })
    }
})

export const { nearSpCleaner } = nearSpSlice.actions
export default nearSpSlice.reducer